// extracted by mini-css-extract-plugin
module.exports = {"information":"EmptyList_information__1-pAm","icon":"EmptyList_icon__29Z3r","modal-card-empty-body":"EmptyList_modal-card-empty-body__3HjN1"};